export default __webpack_public_path__ + "static/media/confirmation.b8207f5a.m4a";